import React, { useState, useEffect } from 'react';
import './Gallery.css';

export default function Gallery({ token }) {
  const [images, setImages] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    loadImages();
  }, []);

  const loadImages = async () => {
    const res = await fetch('/api/images', { headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) setImages(await res.json());
  };

  const upload = async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    await fetch('/api/images', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });
    loadImages();
  };

  const del = async (id) => {
    await fetch(`/api/images/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    loadImages();
  };

  const useAsReference = async () => {
    const img = images.find(i => i.id === selectedId);
    if (img) {
      window.dispatchEvent(new CustomEvent('reference-selected', { detail: img.dataUrl }));
      await fetch('/api/user/last-reference', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ imageId: img.id })
      });
    }
  };

  const useAsPortrait = () => {
    const img = images.find(i => i.id === selectedId);
    if (img) window.dispatchEvent(new CustomEvent('portrait-selected', { detail: img.dataUrl }));
  };

  return (
    <div className="gallery-card">
      <h2>Your Images</h2>
      <div className="gallery-grid">
        {images.map(img => (
          <div key={img.id} className={`gallery-item ${selectedId === img.id ? 'selected' : ''}`} onClick={() => setSelectedId(img.id)}>
            <img src={img.dataUrl} alt="" />
            <span className="delete-img" onClick={(e) => { e.stopPropagation(); del(img.id); }}>âœ•</span>
          </div>
        ))}
        <div className="gallery-item upload-tile" onClick={() => {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.onchange = e => upload(e.target.files[0]);
          input.click();
        }}>
          <i className="fas fa-plus"></i><br />Upload
        </div>
      </div>
      <div className="gallery-actions">
        <button onClick={useAsReference} disabled={!selectedId}>Use as Reference</button>
        <button onClick={useAsPortrait} disabled={!selectedId}>Use as Portrait</button>
        <button onClick={() => {}}>Clear All</button>
      </div>
      <p className="gallery-note">Click an image to select it, then use the buttons above.</p>
    </div>
  );
}
